import { lazy } from 'react';

export default [
  {
    title: 'Consultation',
    component: lazy(() => import('../Consultation/Consultation')),
    url: '/consultation',
    requirePermission: true,
    roles: ['Client'],
  },
];
